<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  all({ page, limit, q }) {
    return axios.get(`document_types?page=${ page }&limit=${ limit }&q=${ q }`, AS.getDefaultHeaders());
  },
  createOrUpdate(documentType) {
    if (documentType.id === null) {
      return axios.post('document_types', { document_type: documentType }, AS.getDefaultHeaders())
    }
    return axios.patch(`document_types/${ documentType.id }`, { document_type: documentType }, AS.getDefaultHeaders())
  },
  destroy(id) {
    return axios.delete(`document_types/${id}`, AS.getDefaultHeaders());
  },
  fetchDocumentTypes() {
    return axios.get('document_types', AS.getDefaultHeaders());
  },
  createDocumentType(documentTypeParams) {
    return axios.post('document_types', { document_type: documentTypeParams }, AS.getDefaultHeaders());
  },
};
</script>
